import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  restoreActionInfo,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveActionStateDescription,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectBinarySwitchActionStateValue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/BinarySwitchActions/SelectBinarySwitchActionStateValue/SelectBinarySwitchActionStateValue'
import SelectBinarySwitchActionStateValueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/BinarySwitchActions/SelectBinarySwitchActionStateValue/SelectBinarySwitchActionStateValue'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectBinarySwitchActionStateValueIOS) : withStyles(SelectBinarySwitchActionStateValue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    isChangeActionStateMode, isChangeActionMode, isEditActionMode, initialAction,
  } = state.scenes.currentSceneCreating
  const { actions } = state.scenes.currentSceneConditionsActions
  return {
    isMobile,
    path,
    isChangeActionStateMode,
    isChangeActionMode,
    isEditActionMode,
    initialAction,
    actions,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  restoreActionInfo,
  saveActionStateDescription,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectBinarySwitchActionStateValueEnhanced = enhance

export default withRouter(SelectBinarySwitchActionStateValueEnhanced)
